import { setLocale } from 'yup';

import { humanizeFieldName } from './ErrorMessageHelper';

// Yup's built-in messages print the raw field path ("billing_zipcode is a required field"). Forms that
// write their own message are untouched; every schema that relies on the defaults now reads the field
// the way a customer would ("Billing zipcode is required"). A schema's own .label() still wins.
const fieldLabel = ({ path, label }: { path?: string; label?: string }) =>
  label || humanizeFieldName(String(path ?? 'this field').replace(/\[\d+\]/g, ''));

setLocale({
  mixed: {
    required: (params) => `${fieldLabel(params)} is required`,
    defined: (params) => `${fieldLabel(params)} is required`,
    notType: (params) => `${fieldLabel(params)} is not valid`,
    oneOf: (params) => `${fieldLabel(params)} is not an allowed value`,
  },
  string: {
    min: (params) => `${fieldLabel(params)} must be at least ${params.min} characters`,
    max: (params) => `${fieldLabel(params)} must be at most ${params.max} characters`,
    length: (params) => `${fieldLabel(params)} must be exactly ${params.length} characters`,
    email: (params) => `${fieldLabel(params)} must be a valid email address`,
    url: (params) => `${fieldLabel(params)} must be a valid URL`,
    matches: (params) => `${fieldLabel(params)} is not in a valid format`,
  },
  number: {
    min: (params) => `${fieldLabel(params)} must be at least ${params.min}`,
    max: (params) => `${fieldLabel(params)} must be at most ${params.max}`,
    integer: (params) => `${fieldLabel(params)} must be a whole number`,
    positive: (params) => `${fieldLabel(params)} must be a positive number`,
  },
  array: {
    min: (params) => `${fieldLabel(params)} needs at least ${params.min} items`,
    max: (params) => `${fieldLabel(params)} can have at most ${params.max} items`,
  },
});
